import React from 'react';
import { EVENT_ICONS, EVENT_NAMES } from './EventStyles';

class CalendarItem extends React.Component {
  getName() {
    const event = this.props.event;
    if (event.event_type === 'show') {
      let location;
      if (event.place.city == null){
        location = `${event.place.state}, ${event.place.country}`;
      }
      if (event.place.state == null){
        location = `${event.place.city}, ${event.place.country}`;
      }
      if (event.place.city == null && event.place.state == null){
        location = `${event.place.country}`;
      }
      if (event.place.city == null && event.place.state == null && event.place.country == null ){
        location = "";
      }
      if (event.place.city != null && event.place.state != null && event.place.country != null){
        if (event.place.city == event.place.state){
          location = `${event.place.city}, ${event.place.country}`;
        } else{
          if (event.place.state === event.place.country){
            location = `${event.place.city}, ${event.place.country}`;
          }else{
            location = `${event.place.city}, ${event.place.state}, ${event.place.country}`;
           }
         }
      }

      return `${location}`;
    }
    return event.name ? event.name : EVENT_NAMES[event.event_type];
  }
  getTitle(event) {
    let title = '';
    if(event.event_type){
      let eventType = event.event_type;
      switch(eventType){
        case 'stay':
          title = 'Hotel';
          break;
        case 'show':
          title = 'Event Day';
          break;
        case 'off':
          title = 'Off Day';
          break;
        case 'trav':
          title = 'Travel Day';
          break;
        case 'prep':
          title = 'Prep/Rehearsal/Practice Day';
          break;
      }
    }
    return title
  }
  renderGroupItem() {
    const event = this.props.event;
    const style = {
      color: '#FFFFF',
    };
    let location;
    if (event.place.city == null){
      location = `${event.place.state}, ${event.place.country}`
    }
    if (event.place.state == null){
      location = `${event.place.city}, ${event.place.country}`
    }
    if (event.place.city == null && event.place.state == null){
      location = `${event.place.country}`
    }
    if (event.place.city == null && event.place.state == null && event.place.country == null ){
      location = ""
    }
    if (event.place.city != null && event.place.state != null && event.place.country != null){
      if (event.place.city == event.place.state){
        location = `${event.place.city}, ${event.place.country}`
      } else{
        if (event.place.state == event.place.country){
           location = `${event.place.city}, ${event.place.country}`;
        } else{
          location = `${event.place.city}, ${event.place.state}, ${event.place.country}`;
        }
       }
    }
    let name = `${event.group_name} @ ${location}`;
    let showIcon = false;
    let title = this.getTitle(event);
    let icon = EVENT_ICONS[this.props.event.event_type];
    if (event.bids.hotel) {
      name = `${event.group_name} - ${event.bids.hotel.name}`;
    } else if (event.event_type === 'nost') {
      name = `${event.group_name} - No hotel needed.`;
    } else {
      style.color = '#FFFFF';
      icon = 'fa-bed';
      showIcon = true
      name = `${event.group_name} @ ${location}`;
    }
    if (icon) {
      let label = `fa ${icon} fa-lg`;
      if(showIcon){
        title = 'No hotel booked';
        label = `fa ${icon} fa-lg fa-stack-1x`;
        return (
          <span>
            <span className="fa-stack aria-hidden">
              <i className={label} style={style} /> 
              <i className="fa fa-ban fa-stack-2x" title={title}></i>
            </span>
            <span>{name}</span>
          </span>
        );
      }else{        
        return (
          <span className="calendar-page-event-icons">
            <i className={label} style={style} title={title}/> {name}
          </span>
        )
      }
    }
    return <span>{name}</span>;
  }
  renderItem() {
    const name = this.getName();
    const style = {};
    const event = this.props.event;
    let title = this.getTitle(event);
    if (EVENT_ICONS[this.props.event.event_type]) {
      const label = `fa ${EVENT_ICONS[this.props.event.event_type]}`;
      return (
        <span className="calendar-page-event-icons">
          <i className={label} aria-hidden="true" title={title} style={style} />
          {name}
        </span>
      );
    }
    return <span>{name}</span>;
  }
  render() {
    if (this.props.group) {
      return this.renderGroupItem();
    }
    return this.renderItem();
  }
}

export default CalendarItem;



// WEBPACK FOOTER //
// src/routes/tours/components/CalendarItem.js